/**
 * The public plan of a space category (#3075, completion plan W0-4): the
 * end-user app's `/plan` page, which shows the category's rooms behind a
 * dropdown and each room's week, for the tenant's website.
 *
 * Built against `apps/end-user/src/routes/routes.ts` (`publicPlanPath`) and
 * its query (`category`, optional `objectId`); a change there changes this.
 */

/** The plan's address for one category on the shared booking app. */
export const publicPlanUrl = (host: string, slug: string, categoryKey: string): string =>
    `https://${host}/${encodeURIComponent(slug)}/plan?category=${encodeURIComponent(categoryKey)}`;

/**
 * The snippet a website pastes. `title` names the frame for screen readers;
 * the height fits a week of hours; `loading="lazy"` keeps a page that shows
 * the plan further down from loading it up front.
 */
export const publicPlanEmbedCode = (url: string, title: string): string =>
    `<iframe src="${url}" title="${title.replace(/&/g, '&amp;').replace(/"/g, '&quot;')}" width="100%" height="900"`
    + ' style="border:0" loading="lazy"></iframe>';
